import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import Privacy from "./Privacy";
import reportWebVitals from "./reportWebVitals";
import TalkingHeadComponent from "./TalkingHead";
import DevTalkingHeadComponent from "./DevTalkingHead";
import DeleteDataScreen from "./DeleteUser";
// @ts-expect-error
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route
          path="/headTalk"
          element={<TalkingHeadComponent interal={false} />}
        />
        <Route
          path="/dev"
          element={<DevTalkingHeadComponent interal={false} />}
        />
        <Route
          path="/interalHeadTalk"
          element={<TalkingHeadComponent interal={true} />}
        />
        <Route 
        path="/delete-user-data"
        element={<DeleteDataScreen />}
        />
      </Routes>
    </Router>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
